module.exports = __webpack_public_path__ + "static/media/1_A1_17.f7d59cd5.png";